import type { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import type { Platform } from '@freelancer/pwa';
import { Pwa } from '@freelancer/pwa';
import { ToastAlertColor, ToastAlertType } from './toast-alert.types';

@Component({
  selector: 'fl-toast-alert-global',
  template: `
    <fl-toast-alert
      i18n="File Viewer loading toast alert"
      [id]="'file-viewer-loading'"
      [timeout]="undefined"
      [closeable]="true"
      [type]="ToastAlertType.LOADING"
    >
      Loading preview
    </fl-toast-alert>
    <fl-toast-alert
      i18n="Geolocation Permission Granted toast alert"
      [id]="'geolocation-permission-granted'"
      [timeout]="10000"
      [closeable]="true"
      [type]="ToastAlertType.SUCCESS"
    >
      Permission granted for Geolocation.
    </fl-toast-alert>
  `,
})
export class ToastAlertGlobalComponent implements OnInit {
  ToastAlertType = ToastAlertType;
  ToastAlertColor = ToastAlertColor;

  platform: Platform;
  isNative: boolean;

  constructor(private pwa: Pwa) {}

  ngOnInit() {
    this.platform = this.pwa.getPlatform();
    this.isNative = this.pwa.isNative();
  }
}
